export const NLC_DOMAINS = new Set([
  "localhost",
  "mb-dev.nlc.com",
  "mb-staging.nlc.com",
  "client.nlc.com",
]);

export const NLC_DOMAIN_PATTERNS = [/^pr-[^.]+\.preview\.nlc\.com$/];

export function isKnownNlcDomain(domain: string): boolean {
  if (NLC_DOMAINS.has(domain)) {
    return true;
  }

  return NLC_DOMAIN_PATTERNS.some((pattern) => pattern.test(domain));
}

export function getPostLoginRedirect(): string {
  if (isKnownNlcDomain(window.location.hostname)) {
    return "/dashboard";
  }

  return "/whitelabel/dashboard";
}
